import logo_black from "../images/logo_black.svg"
import logo_horizontal from "../images/logos/Insight_horizontal_logo.svg"
import { Link } from "react-router-dom"
import dropIcon from "../images/drop_icon.svg"
import ham from "../images/ham.svg"
import SideMenu from "./SideMenu"
import { useState, useEffect } from "react"
import ganitham from "../images/project-dropdown/ganitham.svg"
import disha from "../images/project-dropdown/disha.svg"
import english from "../images/project-dropdown/english.svg"
import spark from "../images/project-dropdown/spark.svg"
import { useNavigate } from "react-router-dom"
import hoverDoodle from "../images/hover-doodle.svg"
import { useLocation } from "react-router-dom"
const Navbar = ({ projectDropdownVisibility, toggleDropdownVisibility, updateCurrentOppor }) => {
    const apiKey = process.env.REACT_APP_READ_API_TOKEN;
    const projectImages = { ganitham: ganitham, disha: disha, english: english, spark: spark};
    const [project, updateProj] = useState(5);
    const navigate = useNavigate()
    const location = useLocation()
    const toggleMenu = () => {
        if (offset == 0) {
            updateOffset(initOffset)
        }
        else {
            updateOffset(0)
        }

    }
    const initOffset = -100
    const [offset, updateOffset] = useState(initOffset)
    const [activeDropdownParent, setActiveDropdownParent] = useState(false)
    const showProjectDrop = () => {
        toggleDropdownVisibility(true)
        setActiveDropdownParent(true)
    }
    const hideProjectDrop = () => {
        toggleDropdownVisibility(false)
        setActiveDropdownParent(false)
    }
    const [activeTab, updateActiveTab] = useState("")
    useEffect(() => {

        if (location.pathname.includes("/projects")) {
            updateActiveTab("Projects")
        }
        else if (location.pathname.includes("/about-us")) {
            updateActiveTab("About Us")
        }
        else if (location.pathname.includes("/our-story")) {
            updateActiveTab("Our Story")
        }
        else if (location.pathname.includes("/team")) {
            updateActiveTab("Team")
        }
        else if (location.pathname.includes("/opportunities")) {
            updateActiveTab("Opportunities")
        }
        else if (location.pathname.includes("/gallery")) {
            updateActiveTab("Gallery")
        }
        else if (location.pathname.includes("/contact-us")) {
            updateActiveTab("Contact us")
        }
        else {
            updateActiveTab("")
        }
    }, [location.pathname])
    
 
    useEffect(() => {

        var myHeaders = new Headers();
        myHeaders.append("Authorization", `bearer ${apiKey}`);

        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            redirect: 'follow'
        };

        fetch("https://cms.insightforinnovation.in/api/projects?sort=sortOrder:ASC&pagination[limit]=4", requestOptions)
            .then(response => response.text())
            .then((result) => {
                var stat = (JSON.parse(result));
                updateProj(stat)
            })
            .catch(error => console.log('error', error));
    }, [])

    return (
        <>
            <div className="nav-fixed">
                <nav className="navbar">
                    <img className="nav-logo" src={logo_black} alt="Insight" onClick={() => { navigate("/"); window.scrollTo(0, 0); updateActiveTab("") }} />
                    <img className="nav-logo-horizontal" src={logo_horizontal} alt="Insight" onClick={() => { navigate("/") }} />
                    <img className="ham" src={ham} alt="menu" onClick={toggleMenu} />
                    <div className="buttonGroup">




<div className={activeTab == "About Us" ? "btn activeTab" : "btn"} onMouseEnter={hideProjectDrop} onClick={() => { window.scrollTo(0, 0); }}>
                            <Link to="/about-us">About Us</Link>
                            <div className="hover-container">
                                <img src={hoverDoodle} alt="doodle" className={activeTab == "About Us" ? "hover-doodle-fixed" : "hover-doodle"} />
                            </div>
                        </div>



                        <div className={activeTab == "Projects" || projectDropdownVisibility ? "btn btn-project activeTab" : "btn btn-project"} onMouseEnter={showProjectDrop}>
                            <Link  >Projects <img src={dropIcon} alt="" /></Link>
                            <div className="hover-container">
                                <img src={hoverDoodle} alt="doodle" className={activeTab == "Projects" ? "hover-doodle-fixed" : "hover-doodle"} />
                            </div>
                            {projectDropdownVisibility && <div className="project-dropdown">

                                <div className="drop-item" onClick={() => {
                                    navigate("/projects/" + project.data[0].attributes.url)

                                }}>
                                    <div className="cirlcle-image">
                                        <img src={projectImages[project.data[0].attributes.projectIcon]} alt={project.data[0].attributes.projectIcon} className="drop-image" />
                                    </div>
                                    
                                    <div className="drop-text-sub">
                                        <p className="main">{project.data[0].attributes.projectTitle}</p>
                                        <p className="sub-text">{project.data[0].attributes.shortDescription}</p>
                                    </div>
                                </div>

                                <div className="drop-item" onClick={() => {
                                    navigate("/projects/" + project.data[1].attributes.url)

                                }}>
                                    <div className="cirlcle-image">
                                        <img src={projectImages[project.data[1].attributes.projectIcon]} alt={project.data[1].attributes.projectIcon} className="drop-image" />
                                    </div>

                                    <div className="drop-text-sub">
                                        <p className="main">{project.data[1].attributes.projectTitle}</p>
                                        <p className="sub-text">{project.data[1].attributes.shortDescription}</p>
                                    </div>
                                </div>

                                <div className="drop-item" onClick={() => {
                                    navigate("/projects/" + project.data[2].attributes.url)

                                }}>
                                    <div className="cirlcle-image">
                                        <img src={projectImages[project.data[2].attributes.projectIcon]} alt={project.data[2].attributes.projectIcon} className="drop-image" />
                                    </div>

                                    <div className="drop-text-sub">
                                        <p className="main">{project.data[2].attributes.projectTitle}</p>
                                        <p className="sub-text">{project.data[2].attributes.shortDescription}</p>
                                    </div>
                                </div>
                                <div className="drop-item" onClick={() => {
                                    navigate("/projects/" + project.data[3].attributes.url)

                                }}>
                                    <div className="cirlcle-image">
                                        <img src={projectImages[project.data[3].attributes.projectIcon]} alt={project.data[3].attributes.projectIcon} className="drop-image" />
                                    </div>

                                    <div className="drop-text-sub">
                                        <p className="main">{project.data[3].attributes.projectTitle}</p>
                                        <p className="sub-text">{project.data[3].attributes.shortDescription}</p>
                                    </div>
                                </div>
                                <div className="view-all" onClick={() => {
                                    navigate("/projects")

                                }}>
                                    View all Projects
                                </div>


                            </div>}


                        </div>
                        <div className={activeTab == "Our Story" ? "btn activeTab" : "btn"} onMouseEnter={hideProjectDrop} onClick={() => { window.scrollTo(0, 0); }}>
                            <Link to="/our-story">Our Story</Link>
                            <div className="hover-container">
                                <img src={hoverDoodle} alt="doodle" className={activeTab == "Our Story" ? "hover-doodle-fixed" : "hover-doodle"} />
                            </div>
                        </div>
                        <div className={activeTab == "Team" ? "btn activeTab" : "btn"} onMouseEnter={hideProjectDrop} onClick={() => { window.scrollTo(0, 0); }}>
                            <Link to="/team">Team</Link>
                            <div className="hover-container">
                                <img src={hoverDoodle} alt="doodle" className={activeTab == "Team" ? "hover-doodle-fixed" : "hover-doodle"} />
                            </div>
                        </div>
                        <div className={activeTab == "Opportunities" ? "btn activeTab" : "btn"} onMouseEnter={hideProjectDrop} onClick={() => { window.scrollTo(0, 0); }}>
                            <Link onClick={() => { updateCurrentOppor("") }} to="/opportunities">Opportunities</Link>
                            <div className="hover-container">
                                <img src={hoverDoodle} alt="doodle" className={activeTab == "Opportunities" ? "hover-doodle-fixed" : "hover-doodle"} />
                            </div>
                        </div>
                        {/* <div className={activeTab == "Gallery" ? "btn activeTab" : "btn"} onMouseEnter={hideProjectDrop} onClick={() => { window.scrollTo(0, 0); }}>
                            <Link to="/gallery">Gallery</Link>
                            <div className="hover-container">
                                <img src={hoverDoodle} alt="doodle" className={activeTab == "Gallery" ? "hover-doodle-fixed" : "hover-doodle"} />
                            </div>
                        </div> */}
                        <div className={activeTab == "Contact us" ? "btn activeTab" : "btn"} onMouseEnter={hideProjectDrop} onClick={() => { window.scrollTo(0, 0); }}>
                            <Link to="/contact-us">Contact us</Link>
                            <div className="hover-container">
                                <img src={hoverDoodle} alt="doodle" className={activeTab == "Contact us" ? "hover-doodle-fixed" : "hover-doodle"} />
                            </div>
                        </div>
                    </div>

                    

                    <SideMenu offset={offset} toggleMenu={toggleMenu} />
                </nav>
            </div>

        </>
    )
}

export default Navbar
